import { LOCAL_FONT_PROTOCOL } from "@/lib/common";

import type { DrawinkFontFaceDescriptor } from "../Fonts";

export const EmojiFontFaces: DrawinkFontFaceDescriptor[] = [
  {
    uri: LOCAL_FONT_PROTOCOL,
  },
];
